import fetchApi from "@lib/api-fetcher/fetchApi";
import { API_ROUTES } from "@utils/constants";
import { reportError } from "@utils/errorReporting";

import validatePackageSizesResponse from "../models/packageSizes";
import { TPackageSize } from "../types";
import mapPackageSizesResponse from "../utils/mapPackageSizesResponse";

type TPackageSizesParams = {
  countryFrom: string;
  countryTo?: string;
  deliveryMethod?: string;
};

const mapPackageSizesRequestParams = (countryFrom, countryTo, deliveryMethod): TPackageSizesParams => ({
  countryFrom,
  countryTo,
  deliveryMethod,
});

const loadPackageSizes = async (
  { countryFrom, countryTo, deliveryMethod }: TPackageSizesParams,
  locale?: string,
  hostname?: string
): Promise<TPackageSize[]> => {
  if (!countryTo) {
    return [];
  }
  try {
    const response = await fetchApi({
      url: API_ROUTES.DIMENSIONS,
      params: mapPackageSizesRequestParams(countryFrom, countryTo, deliveryMethod),
      locale,
      hostname,
    });
    const packageSizesResponse = validatePackageSizesResponse(response.data);
    return mapPackageSizesResponse(packageSizesResponse);
  } catch (err) {
    reportError(err, { module: "order" });
    return [];
  }
};
export default loadPackageSizes;
